import { render, staticRenderFns } from "./StateRecord.vue?vue&type=template&id=2634e618&scoped=true&"
import script from "./StateRecord.vue?vue&type=script&lang=js&"
export * from "./StateRecord.vue?vue&type=script&lang=js&"
import style0 from "./StateRecord.vue?vue&type=style&index=0&id=2634e618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634e618",
  null
  
)

export default component.exports